var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('requirement-filter',{on:{"change":_vm.onChange}}),_c('br'),_c('req-dev-time-rank',{attrs:{"filter-form":_vm.filterForm}}),_c('br'),_c('req-add-rem-trend',{attrs:{"filter-form":_vm.versionFilterForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }